












































import { Component, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { CampaignStatus } from '@/data/models/campaign.model';

@Component
export default class CampagnaFilter extends Vue {

	advancedSearch: Search;

	searchParam: any = new class {
		title?: string;
		status = CampaignStatus.ACTIVE;
	};

	state!: State;

	statusItems: string[] = Object.keys(CampaignStatus).map(
		// @ts-ignore
		(k: string) => CampaignStatus[k]
	);

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('campaign');
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);

		if (this.searchParam.title) this.advancedSearch.addLikeFilter('campaign.title', this.searchParam.title);
		if (this.searchParam.status) this.advancedSearch.addSimpleFilter('campaign.status', this.searchParam.status);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.title = undefined;
		this.searchParam.status = CampaignStatus.ACTIVE;
		this.search();
	}

}
